// Initial state
function initialState() {
	return {
		details: {}
	}
}

const state = initialState()

// Getters
const getters = {
	listTint: (state) => {
		return state.details
	}
}

// Actions
const actions = {
	resetState ({ state, commit }) {
		commit('reset')
	},
	addTint ({ state, commit }, tint) {
		commit('setTint', tint)
	},
	deleteTint ({ state, commit }) {
		commit('setTint', {})
	}
}

// Mutations
const mutations = {
	reset (state) {
		// acquire initial state
		const s = initialState()
		Object.keys(s).forEach(key => {
			state[key] = s[key]
		})
	},
	setTint (state, tint) {
		state.details = tint
	}
}

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations
}
